/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ChevronLeft = [["path", { d: "m15 18-6-6 6-6" }]];

export { ChevronLeft as default };
//# sourceMappingURL=chevron-left.js.map
